const translations = {
    "service": "servicios",
    "products": "productos",
    "product": "producto",
    "categories": "categorias",
    "provider": "proveedor",
    "providers": "proveedores",
};

const translateToEnglish = (param) => {
    const invertedTranslations = Object.fromEntries(
        Object.entries(translations).map(([en, es]) => [es, en])
    );
    return invertedTranslations[param] || param; // Si no encuentra una traducción, devuelve el mismo valor
};

const translateToSpanish = (param) => {
    return translations[param] || param;
};

export { translations, translateToEnglish, translateToSpanish };
